import { useEffect, useRef } from 'react';

export function useReveal() {
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    // Observe all .reveal elements in the document
    const els = document.querySelectorAll('.reveal');
    els.forEach((el) => obs.observe(el));

    return () => obs.disconnect();
  }, []);

  return ref;
}
